import { baseApi } from "@/shared/api/baseApi";
import { ENDPOINTS } from "@/shared/api/endpoints";

const TIMEOUT_MS = 3000;

/**
 * FlagForge: valutazione server-side di tutti i flag per l'utente. Fail-safe come il legacy:
 * config mancante, errore di rete, risposta non ok o timeout -> {} (ogni feature spenta).
 */
export const featureFlagsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    evaluateFeatureFlags: build.query<Record<string, boolean>, string>({
      queryFn: async (userId) => {
        const base = import.meta.env.VITE_FLAGFORGE_URL;
        const key = import.meta.env.VITE_FLAGFORGE_KEY;
        if (!base || !key) return { data: {} };
        // Timeout con Promise.race e non con AbortController: nei test la patch di Request in
        // src/test/setup.ts toglie il signal, e il comportamento visto da fuori e' lo stesso ({} dopo 3 s).
        let timer = 0;
        const timeout = new Promise<{ data: Record<string, boolean> }>((resolve) => {
          timer = window.setTimeout(() => resolve({ data: {} }), TIMEOUT_MS);
        });
        const request = async (): Promise<{ data: Record<string, boolean> }> => {
          try {
            const response = await fetch(`${base}${ENDPOINTS.featureFlagsEvaluateAll}`, {
              method: "POST",
              headers: { "Content-Type": "application/json", Authorization: `Bearer ${key}` },
              body: JSON.stringify({ userId: String(userId) }),
            });
            if (!response.ok) return { data: {} };
            const data = (await response.json()) as Record<string, boolean> | null;
            return { data: data ?? {} };
          } catch (error) {
            console.error("FlagForge evaluate/all fallito:", error);
            return { data: {} };
          }
        };
        try {
          return await Promise.race([request(), timeout]);
        } finally {
          window.clearTimeout(timer);
        }
      },
      providesTags: ["FeatureFlags"],
    }),
  }),
});

export const { useEvaluateFeatureFlagsQuery } = featureFlagsApi;
